const images = require.context('../../../public/images', true);
window.imagePath = (name) => images(`./${name}`, true);

import 'stylesheets/application.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'jquery-modal';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import '@/scripts';

import {
  TopNavSearchForm,
  TopNavHeader,
  CompanyPicker,
  InstallRequestButton,
} from '@/react/components';
import Popover from '@/react/shared/Popover';

import {
  MarketplaceListingContainer,
  MarketplaceAppContainer,
  FAQContainer,
} from '@/react/views/V2';

// Make React/Jquery Dependencies Global For Rails View Consumption
window.React = React;
window.ReactDOM = ReactDOM;
window.$ = $;
window.jQuery = $;

window.TopNavSearchForm = TopNavSearchForm;
window.TopNavHeader = TopNavHeader;
window.Popover = Popover;
window.CompanyPicker = CompanyPicker;
window.InstallRequestButton = InstallRequestButton;
window.MarketplaceListingContainer = MarketplaceListingContainer;
window.MarketplaceAppContainer = MarketplaceAppContainer;
window.FAQContainer = FAQContainer;
